import { useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';

const TimelineListImage = ({ src, alt = '', ...props }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '80px' },
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      aria-label={alt}
      role="img"
      className={styles.sliderImgBg}
      style={{
        backgroundImage: visible ? `url(${src})` : 'none',
      }}
      {...props}
    />
  );
};

export default TimelineListImage;